var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"messages-tabs",attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":""},on:{"activate-tab":function($event){return _vm.$emit('clearSelected')}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }